import { gql } from "@apollo/client";

export const EXPORT_CUSTOMERS_URL = gql`
  query exportCustomers($projectId: ID!, $fileType: ExportFileType!, $option: CustomerOptionInput!) {
    exportCustomers(projectId: $projectId, fileType: $fileType, option: $option)
  }
`;
